// Minimal, safe markdown renderer for the ingested text (## / ### headings,
// > blockquotes, ordered/unordered lists, **bold**, paragraphs).
import React from "react";

function renderInline(text, key) {
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((p, i) => {
    if (p.startsWith("**") && p.endsWith("**")) {
      return <strong key={`${key}-${i}`} className="font-semibold">{p.slice(2, -2)}</strong>;
    }
    return <React.Fragment key={`${key}-${i}`}>{p}</React.Fragment>;
  });
}

export default function Markdown({ text }) {
  const lines = (text || "").split("\n");
  const blocks = [];
  let list = null;
  let listType = null;

  const flush = () => {
    if (list) {
      const Tag = listType === "ol" ? "ol" : "ul";
      blocks.push(
        <Tag key={`l-${blocks.length}`} className={listType === "ol" ? "list-decimal" : "list-disc"}>
          {list.map((it, i) => <li key={i}>{renderInline(it, `li-${blocks.length}-${i}`)}</li>)}
        </Tag>
      );
      list = null; listType = null;
    }
  };

  lines.forEach((raw, idx) => {
    const line = raw.trimEnd();
    if (!line.trim()) { flush(); return; }
    if (line.startsWith("### ")) { flush(); blocks.push(<h3 key={idx}>{renderInline(line.slice(4), idx)}</h3>); return; }
    if (line.startsWith("## ")) { flush(); blocks.push(<h2 key={idx}>{renderInline(line.slice(3), idx)}</h2>); return; }
    if (line.startsWith("# ")) { flush(); blocks.push(<h2 key={idx}>{renderInline(line.slice(2), idx)}</h2>); return; }
    if (line.startsWith("> ")) { flush(); blocks.push(<blockquote key={idx}>{renderInline(line.slice(2), idx)}</blockquote>); return; }
    const ol = line.match(/^\d+\.\s+(.*)/);
    const ul = line.match(/^[-*]\s+(.*)/);
    if (ol) { if (listType !== "ol") flush(); listType = "ol"; list = list || []; list.push(ol[1]); return; }
    if (ul) { if (listType !== "ul") flush(); listType = "ul"; list = list || []; list.push(ul[1]); return; }
    flush();
    blocks.push(<p key={idx}>{renderInline(line, idx)}</p>);
  });
  flush();

  return <div className="prose-indic">{blocks}</div>;
}
